import clsx from 'clsx'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../hooks/useStore'
import { handleSidebarSelectSubMenu } from '../../store/features/dashboardUi/dashboardUiSlice'

type IProps = {
  id: string
  key: string
  title: string
  path: string
}
const SubMenuItem: FC<IProps> = ({ key, id, title, path }) => {
  const { selectedSubMenu } = useAppSelector((state) => state.dashboardUi.sidebar)
  const dispatch = useAppDispatch()

  const handleSubMenuItemClick = (id: string) => {
    dispatch(handleSidebarSelectSubMenu(id))
  }

  return (
    <li
      key={key}
      className={clsx('p-2 mb-1 hover:text-blue-400', selectedSubMenu === id && 'text-blue-400')}
      id={id}
      onClick={() => handleSubMenuItemClick(id)}
    >
      <Link key={key} to={path}>
        {title}
      </Link>
    </li>
  )
}

export default SubMenuItem
